import { intl } from "LocaleWrapper";

export enum ProductTabs {
	DangerousGoods = "DANGEROUS_GOODS",
	Nstr = "NSTR",
	Idtf = "IDTF",
	Documents = "DOCUMENTS"
}

export const headerMap = {
	"unNumber": `1 ${intl.formatMessage({  id: "PRODUCT_ADN_UN_NUMBER" })}`,
	"properShippingNameEN": `2a ${intl.formatMessage({  id: "PRODUCT_ADN_PROPER_SHIPPING_NAME_EN" })}`,
	"properShippingNameNL": `2b ${intl.formatMessage({  id: "PRODUCT_ADN_PROPER_SHIPPING_NAME_NL" })}`,
	"properShippingNameDE": `2c ${intl.formatMessage({  id: "PRODUCT_ADN_PROPER_SHIPPING_NAME_DE" })}`,
	"properShippingNameFR": `2d ${intl.formatMessage({  id: "PRODUCT_ADN_PROPER_SHIPPING_NAME_FR" })}`,
	"classNumber": `3a ${intl.formatMessage({  id: "PRODUCT_ADN_CLASS_NUMBER" })}`,
	"classificationCode": `3b ${intl.formatMessage({  id: "PRODUCT_ADN_CLASSIFICATION_CODE" })}`,
	"packingGroup": `4 ${intl.formatMessage({  id: "PRODUCT_ADN_PACKING_GROUP" })}`,
	"hazards": `5 ${intl.formatMessage({  id: "PRODUCT_ADN_HAZARDS" })}`,
	"tankerType": `6 ${intl.formatMessage({  id: "PRODUCT_ADN_TANKER_TYPE" })}`,
	"cargoTankDesign": `7 ${intl.formatMessage({  id: "PRODUCT_ADN_CARGO_TANK_DESIGN" })}`,
	"cargoTankType": `8 ${intl.formatMessage({  id: "PRODUCT_ADN_CARGO_TANK_TYPE" })}`,
	"cargoTankEquipment": `9 ${intl.formatMessage({  id: "PRODUCT_ADN_CARGO_TANK_EQUIPMENT" })}`,
	"openingPressureRelieveValve": `10 ${intl.formatMessage({  id: "PRODUCT_ADN_OPENING_PRESSURE_RELIEVE_VALVE" })}`,
	"maxFillingDegreePercentage": `11 ${intl.formatMessage({  id: "PRODUCT_ADN_MAX_FILLING_DEGREE_PERCENTAGE" })}`,
	"density": `12a ${intl.formatMessage({  id: "PRODUCT_ADN_DENSITY" })}`,
	"densityTemperature": `12b ${intl.formatMessage({  id: "PRODUCT_ADN_DENSITY_TEMPERATURE" })}`,
	"samplingType": `13 ${intl.formatMessage({  id: "PRODUCT_ADN_SAMPLING_TYPE" })}`,
	"permissiblePumpChamberUnderDeck": `14 ${intl.formatMessage({  id: "PRODUCT_ADN_PERMISSIBLE_PUMP_CHAMBER_UNDER_DECK" })}`,
	"temperatureClass": `15 ${intl.formatMessage({  id: "PRODUCT_ADN_TEMPERATURE_CLASS" })}`,
	"explosionGroup": `16 ${intl.formatMessage({  id: "PRODUCT_ADN_EXPLOSION_GROUP" })}`,
	"explosionProtectionRequired": `17 ${intl.formatMessage({  id: "PRODUCT_ADN_EXPLOSION_PROTECTION_REQUIRED" })}`,
	"requiredEquipment": `18 ${intl.formatMessage({  id: "PRODUCT_ADN_REQUIRED_EQUIPMENT" })}`,
	"numberOfBlueConesOrLights": `19 ${intl.formatMessage({  id: "PRODUCT_ADN_NUMBER_OF_BLUE_CONES_OR_LIGHTS" })}`,
	"extraRequirements": `20 ${intl.formatMessage({  id: "PRODUCT_ADN_EXTRA_REQUIREMENTS" })}`,
};
